import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ErrorIcon } from '../CustomIcons';

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  header: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#455775'
  },
  body: {
    textAlign: 'center',
    padding: ' 0 16px',
    color: '#455775'
  },
  button: {
    borderRadius: 32
  },
  closeButtonWrapper: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    color: theme.palette.colorPalette[1],

    '&:hover': {
      cursor: 'pointer'
    }
  },
  actionButtonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2)
  }
}));

const Buttons = ({ actions, closeModal }) =>
  actions?.map(({ onClick, href, label } = {}) =>
    onClick ? (
      <Button
        onClick={async () => {
          await onClick();
          closeModal();
        }}
        color="primary"
        variant="contained"
      >
        {label}
      </Button>
    ) : (
      <Button rel="noopener noreferrer" href={href} color="primary" variant="contained">
        {label}
      </Button>
    )
  );

const ErrorModal = ({ closeModal, actions, content: ModalCustomContent } = {}) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.closeButtonWrapper} onClick={closeModal}>
        <HighlightOffIcon color="primary" />
      </div>
      <div className={classes.iconWrapper}>
        <ErrorIcon />
      </div>
      <div>
        <ModalCustomContent />
      </div>
      {actions && (
        <div className={classes.actionButtonsWrapper}>
          <Buttons actions={actions} closeModal={closeModal} />
        </div>
      )}
    </>
  );
};

ErrorModal.propTypes = {
  closeModal: PropTypes.func,
  actions: PropTypes.array,
  content: PropTypes.string
};

export default ErrorModal;
